export default __webpack_public_path__ + "static/media/Sarah-Hayes.70080656.png";